import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { QUOTE_TOOL_STORAGE_KEY } from '@lx/quote-tool/lite/shared/types';
import { getBaseHrefFactory, setBaseHrefFactory } from '@lx/quote-tool/shared/utils/functions';
import { TimezoneService } from '@lx/quote-tool/shared/services';
import { CustomisedNGXLoggerServerService, getApplicationProviders } from '@lx/shared/app-init';
import { httpErrorInterceptorFn, WHITELISTED_ERROR_CODES } from '@lx/shared/errors';
import { APP_NAME, BASE_HREF, ENVIRONMENT } from '@lx/shared/tokens';
import { LoggerModule, NgxLoggerLevel, TOKEN_LOGGER_SERVER_SERVICE } from 'ngx-logger';
import { appRoutes } from './app.routes';
import { getAppInitializers } from './utils';
import { RuntimeEnvironment } from '@lx/shared/types';
import { APPLICATION_CONFIGURATION_SERVICE } from '@lx/shared/app-config';
import { ApplicationConfigurationService } from './services';

export const getAppConfig = (runtimeEnvironment: RuntimeEnvironment): ApplicationConfig => ({
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptors([httpErrorInterceptorFn])),
    { provide: BASE_HREF, useFactory: getBaseHrefFactory, deps: [ENVIRONMENT] },
    { provide: APP_BASE_HREF, useFactory: setBaseHrefFactory, deps: [BASE_HREF] },
    provideRouter(appRoutes),
    importProvidersFrom(
      LoggerModule.forRoot(
        {
          level: NgxLoggerLevel.DEBUG,
          disableConsoleLogging: false,
          serverLogLevel: NgxLoggerLevel.ERROR,
        },
        {
          serverProvider: {
            provide: TOKEN_LOGGER_SERVER_SERVICE,
            useClass: CustomisedNGXLoggerServerService,
          },
        },
      ),
    ),
    ...getApplicationProviders(runtimeEnvironment),
    { provide: APPLICATION_CONFIGURATION_SERVICE, useClass: ApplicationConfigurationService },
    ...getAppInitializers(runtimeEnvironment), // Then initialize app (uses query params)
    { provide: WHITELISTED_ERROR_CODES, useValue: [410, 404] },
    { provide: APP_NAME, useValue: 'online-quote-tool' },
    { provide: ENVIRONMENT, useValue: runtimeEnvironment },
    { provide: QUOTE_TOOL_STORAGE_KEY, useValue: 'ONLINE_QT_STATE' },
    TimezoneService,
  ],
});
